import React from 'react';
import { DataTable } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { vulnerabilities } from '../data/mockData';
import { Download } from 'lucide-react';
import { toast } from 'sonner';

export default function Vulnerabilities() {
  const handleExportCSV = () => {
    const headers = ['Name', 'Severity', 'OWASP', 'CVSS Score', 'Description'];
    const rows = vulnerabilities.map(vuln => [
      vuln.name,
      vuln.severity,
      vuln.owasp,
      vuln.cvss,
      `"${vuln.description}"`
    ]);
    
    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'vulnerabilities_database.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    toast.success('Vulnerabilities exported to CSV');
  };

  const columns = [
    { key: 'name', label: 'Name' },
    { 
      key: 'severity', 
      label: 'Severity',
      render: (row) => <StatusBadge severity={row.severity} />
    },
    { key: 'owasp', label: 'OWASP' },
    { 
      key: 'cvss', 
      label: 'CVSS Score',
      render: (row) => (
        <span className="cvss-score" data-testid={`cvss-${row.id}`}>
          {row.cvss}
        </span>
      )
    },
    { 
      key: 'description', 
      label: 'Description',
      render: (row) => (
        <span className="description-cell">{row.description}</span>
      )
    }
  ];

  return (
    <div className="page-container" data-testid="vulnerabilities-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Vulnerabilities</h1>
          <p className="page-subtitle">Known vulnerability database</p>
        </div>
        <button 
          className="btn-success"
          onClick={handleExportCSV}
          data-testid="export-vulnerabilities-button"
        >
          <Download size={18} />
          <span>Export CSV</span>
        </button>
      </div>

      <DataTable 
        columns={columns} 
        data={vulnerabilities}
        searchable={true}
        emptyMessage="No vulnerabilities found"
      />
    </div>
  );
}
